// FIXME
import t from 'tcomb';

const JSON_Value = t.union([t.Str, t.Num, t.Bool]);

JSON_Value.format = function(locale, schema, value) {
  //t.assert(Locale.is(locale));
  //assert(Schema.is(schema)); fixme
  //assert(Maybe(JSON_Value).is(value)); fixme

  if (t.Nil.is(value)) {
    return '';
  }
  if (schema.type === 'number') {
    return schema.integer ?
      locale.format_integer(value) :
      locale.format_number(value, schema.digits);
  }
  return String(value);
};


export default JSON_Value;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/JSON_Value.js
 **/